import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'datemonthformat' })
export class DateMonthFormatterPipe implements PipeTransform{
    transform(date: string) {
        var splitted =undefined;
        if(date){
         splitted = date.split("-", 3); 
         return splitted[0]+'/'+splitted[1];
    }
    return "";
    }
    
}